import React, { Component } from 'react';
import _ from 'lodash';

import CircularProgress from '@material-ui/core/CircularProgress';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles } from '@material-ui/core';


const styles = (theme: Theme) => createStyles({
    root: {

    },
    loaderContainer: {
        background: 'rgba(255,255,255,0.8)',
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 500,
    },
    progress: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        marginTop: '-12px',
        marginLeft: '-12px'
    },
});


//@ts-ignore
interface MyPATLocalLoaderProps extends WithStyles<typeof styles> {
    classes: any,
}
interface MyPATLocalLoaderState {
}

class MyPATLocalLoader extends Component<MyPATLocalLoaderProps, MyPATLocalLoaderState>{
    constructor(props: MyPATLocalLoaderProps, state: MyPATLocalLoaderState) {
        super(props);
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.loaderContainer}>
                <CircularProgress className={classes.progress} />
            </div>
        )
    }
}

// @ts-ignore
export default withStyles(styles)(MyPATLocalLoader);